import { useEffect, useState } from "react";
import { imgURL } from "./SVGImageUtil";

const HeroImage = ({image, altText, section}) => {

    const [loading, setLoading] = useState(true);
    const [imgSrc, setImgSrc] = useState("");
    const [imgStyle, setImgStyle] = useState({});

    useEffect(() => {
        if(image) {
            const img = new Image();
            img.src = imgURL(image);
            console.log("img.src / hero", imgURL(image));
            img.onload = () => {
                setImgSrc(imgURL(image));
                setLoading(false);
                console.log("img dims", img, img.width, img.height);
                setImgStyle({width : img.width, height : img.height});
            }
        }
    }, [image])

    const content = () => {
        if(image && loading) {
            return (<div style={{...imgStyle}}
            className={`hero_holder loading ${section}`} key={`hero_holder_${section}_loader`}>
                <div className="spinnyNiconByrne">
                N&B</div></div>)
        }
        return (<div 
        className={'hero_holder'} key={`hero_holder_${altText}`}>
            <img className="hero_image" alt={altText} src={imgSrc} />
        </div>)
    }

    return (
       <>{content()}</>
    )
}

export default HeroImage;